import { Mui, Image } from '@onedesign/ui';
import { ThemeMode } from 'theme/types';
import { Button } from '@mui/material';

const { Box, styled, FormControl } = Mui;
export const StyledFormContainer = styled(Box)({
  '> form': {
    display: 'flex',
    flexDirection: 'column',
  },
  '@media(max-width: 1024px)': {
    height: 'auto',
  },
});
export const StyledFormControl = styled(FormControl)({
  textAlign: 'left',
  marginTop: '1.5rem',
  width: '100%',
  // flex: 1,
});
export const StyledRegisterMain = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexGrow: 1,
  padding: '64px 70px 52px 70px',
  backgroundColor:
    theme.palette.mode === ThemeMode.Dark
      ? theme.palette.grey[800]
      : theme.palette.grey[100],
  borderRadius: '0px 20px 20px 0px',
  '& > h2': {
    color:
      theme.palette.mode === ThemeMode.Dark
        ? theme.palette.grey[100]
        : theme.palette.grey[700],
    margin: '12px 0',
    fontWeight: 700,
  },
  '& > div, & > button': {
    margin: '12px 0',
    width: '100%',
  },
  '@media(max-width: 1024px)': {
    borderRadius: '0 0 20px 20px',
    padding: '24px',
    height: 'auto',
    position: 'initital',
    borderTop: `1px solid transparent`,
  },
}));

export const StyledSwitchToLoginBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  marginTop: 24,
});

export const StyledSwitchToLoginButton = styled(Button)(({ theme }) => ({
  '&:hover': {
    background: 'transparent',
  },
  padding: 0,
  color: theme.palette.grey[600],
}));

// Symbolic graph
export const StyledRegisterSymbolContainer = styled('div')({
  maxWidth: '263px',
  position: 'absolute',
  right: '-30%',
  bottom: '8%',
  '@media(max-width: 1024px)': {
    display: 'none',
  },
});
export const StyledRegisterSymbol = styled(Image)({});
